import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { FaFlag } from 'react-icons/fa'
import {
  FormTextArea,
  FormInput,
  FormDropDownList,
  FormNumericTextBox,
  FormDropDownListFilter,
  FormDateTimePicker,
  FormMultiSelect,
} from '../FormComponents'
import { getMatchingClientSite, getSitesDropdown, getTargetSite } from '../../../data/siteData'
import { getClientsDropdown } from '../../../data/clientData'
import { getEnquirysourceDropdown } from '../../../data/enquirysourceData'
import { getDepartmentDropdown } from '../../../data/departmentData'
import { getWorktypeDropdown } from '../../../data/worktypeData'
import { getNotifiableWorks } from '../../../data/notifiableWorkData'
import { getEmployeeDropdown } from '../../../data/employeeData'
import { dropDown } from '../../../data/interfaces'
import { requiredValidator } from '../Validators'
import Divider from '../../Layout/Divider'
import { getTaxCodesDropdown } from '../../../data/taxCodeData'
import { Loader, LoaderType } from "@progress/kendo-react-indicators";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Label } from '@progress/kendo-react-labels';
import { useToast } from '../../../contexts/ToastContext'
import JobsRemidners from './JobsReminders'
import { JobReminder, deleteServiceReminder, getJobReminders } from '../../../data/serviceReminderData'
import { getAddressesForClientDropdown, getClientsForClientsDropdown, getClientByIdV2 } from '../../../data/accountsData'

const invoiceTypesDropdown = [
  "Quoted works",
  "Call out/Small works",
  "First hour callout"
];

const AddJobForm = (props: any) => {
  const [siteData, setSiteData] = useState<dropDown[]>([])
  const [siteDataOrig, setSiteDataOrig] = useState<dropDown[]>([])
  const [clientData, setClientData] = useState<dropDown[]>([])
  const [clientDataOrig, setClientDataOrig] = useState<dropDown[]>([])
  const [enquirysourceData, setEnquirysourceData] = useState<dropDown[]>([])
  const [departmentData, setDepartmentData] = useState<dropDown[]>([])
  const [worktypeData, setWorktypeData] = useState<dropDown[]>([])
  const [notifiableWorksOptions, setNotifiableWorksOptions] = useState<string[]>([])
  const [notifiableWorks, setNotifiableWorks] = useState<string[]>([])
  const [employeeData, setEmployeeData] = useState<dropDown[]>([])
  const [employeeDataOrig, setEmployeeDataOrig] = useState<dropDown[]>([])
  const [employeeProjectData, setEmployeeProjectData] = useState<dropDown[]>([])
  const [taxCodeData, setTaxCodeData] = useState<dropDown[]>([])
  const [buttonSpinner, setButtonSpinner] = useState<boolean>(false)
  const [invoiceTypeTemplate, setInvoiceTypeTemplate] = useState<string>('')
  const [matchSiteActive, setMatchSiteActive] = useState(false)
  const [clientId, setClientId] = useState(0)
  const [siteId, setSiteId] = useState(0)
  const [jobReminders, setJobReminders] = useState<JobReminder[]>([])
  const [siteAddr, setSiteAddr] = useState({ text: '', value: 0 })
  const [contact, setContact] = useState({ text: '', value: 0 })
  const [isBadDebter, setIsBadDebter] = useState(false)



  const { showToast } = useToast()

  useEffect(() => {
    setWorktypeData(props.updatedWorkTypes)
  }, [props.updatedWorkTypes])

  useEffect(() => {
    const fetchSiteData = async () => {
      const siteData = await getSitesDropdown('')
      setSiteData(siteData)
      setSiteDataOrig(siteData)
    }

    const fetchClientData = async () => {
      const clientData = await getClientsDropdown('')
      setClientData(clientData)
      setClientDataOrig(clientData)
    }

    const fetchEnquirysourceData = async () => {
      const enquirysourceData = await getEnquirysourceDropdown()
      setEnquirysourceData(enquirysourceData)
    }

    const fetchDepartmentData = async () => {
      const departmentData = await getDepartmentDropdown()
      setDepartmentData(departmentData)
    }

    const fetchWorktypeData = async () => {
      const worktypeData = await getWorktypeDropdown()
      setWorktypeData(worktypeData)
    }

    const fetchNotifiableWorks = async () => {
      const works = await getNotifiableWorks()
      setNotifiableWorksOptions(works)
    }

    const fetchTaxCodeData = async () => {
      const taxCodeData = await getTaxCodesDropdown()
      setTaxCodeData(taxCodeData)
    }

    const fetchEmployeeData = async () => {
      const employeeData = await getEmployeeDropdown('')
      setEmployeeData(employeeData)
      setEmployeeProjectData(employeeData)
      setEmployeeDataOrig(employeeData)
    }

    fetchSiteData();
    fetchTaxCodeData();
    fetchClientData();
    fetchEnquirysourceData();
    fetchDepartmentData();
    fetchWorktypeData();
    fetchNotifiableWorks();
    fetchEmployeeData();
  }, [])

  const handleSubmit = (dataItem: any) => {
    // alert(JSON.stringify(dataItem, null, 2));
    console.log(dataItem);

    setButtonSpinner(true)

    dataItem.siteAddr = siteAddr
    dataItem.contact = contact
    dataItem.notifiableWorks = notifiableWorks

    if (invoiceTypeTemplate != null || invoiceTypeTemplate != undefined) {
      dataItem.description = invoiceTypeTemplate + ' - ' + dataItem.description;
    } else {
      dataItem.description = dataItem.description;
    }

    if (!dataItem.enquirysourceId) {
      const newDataItem = { ...dataItem, enquirysourceId: 0 }
      props.onJobSubmit(newDataItem)
    }
    else {
      props.onJobSubmit(dataItem)
    }
    deleteReminders()
  }

  //Search filters
  const searchSiteDropdown = (searchTerm: string) => {
    const fetchSiteData = async (search: string) => {
      await getSitesDropdown(search).then((result) => {
        setSiteData(result)
      })
    }

    fetchSiteData(searchTerm)
  }

  const searchClientDropdown = (searchTerm: string) => {
    const fetchClientData = async (search: string) => {
      await getClientsDropdown(search).then((result) => {
        setClientData(result)
      })
    }

    fetchClientData(searchTerm)
  }

  const searchEmployeeDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }

  const searchEmployeeProjectDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeProjectData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }


  const handleCheckSiteExists = async () => {
    if (matchSiteActive === true) {
      await getMatchingClientSite(clientId).then((result) => {
        if (result !== null && result !== undefined) {
          const matchingId = (result as any).key
          console.log(matchingId)

          getTargetSite(matchingId).then((result) => {
            console.log(result)

            const newSiteObject = {
              value: result.siteId,
              text: result.siteAddr
            }

            console.log(newSiteObject)
            setSiteData([newSiteObject])
          })


          showToast('Site matched', 'success')
        } else {
          showToast('No matching site, try searching manually', 'error')
        }
      })
    } else {
      showToast('Select a client', 'error')
    }
  }


  //Add buttons
  const handleAddClient = () => {
    props.onAddClientToggle()
  }
  const handleAddSite = () => {
    props.onAddSiteToggle()
  }
  const handleAddWorktype = () => {
    props.onAddWorktypeToggle()
  }

  const findMatchingReminders = async () => {
    if (clientId !== 0 && siteId !== 0) {
      const reminders = await getJobReminders(clientId, siteId);
      setJobReminders(reminders);
      console.log("Reminders: ", reminders)
    }
  }

  useEffect(() => {
    findMatchingReminders();
  }, [clientId, siteId])

  interface Reminders {
    id: number;
    checked: boolean;
  }
  const [reminders, setReminders] = useState<Reminders[]>([]);

  const handleCompleteReminder = async (id: number, checked: boolean) => {
    setReminders((prev) => {
      const updatedReminders = prev.map((reminder) => {
        if (reminder.id === id) {
          return { ...reminder, checked };
        }
        return reminder;
      });
      const existingReminder = prev.find((reminder) => reminder.id === id);
      if (!existingReminder) {
        return [...prev, { id, checked }];
      }
      return updatedReminders;
    });
  }

  const deleteReminders = async () => {
    reminders.forEach(async (reminder) => {
      deleteServiceReminder(reminder.id, 0).catch(err => console.log(err));
    });
  }

  const getAndStoreAddressesForCustomer = async (customerId: number) => {
    try {
      const res = await getAddressesForClientDropdown(customerId);
      setSiteData(res);
      setSiteAddr({
        text: res.length === 1 ? res[0]?.text || '' : '',
        value: res.length === 1 ? res[0]?.value || 0 : 0,
      }
      );
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (clientId !== 0) {
      getAndStoreAddressesForCustomer(clientId);
    }
  }, [clientId])


  // Contacts for client
  const [contactsForClient, setContactsForClient] = useState<dropDown[]>([]);

  const getAndStoreContactsForCustomer = async (customerId: number) => {
    try {
      const res = await getClientsForClientsDropdown(customerId);
      setContactsForClient(res);
      setContact((prev: any) => ({
        text: res.length === 1 ? res[0]?.text || '' : '',
        value: res.length === 1 ? res[0]?.value || 0 : 0,
      }))

    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (clientId !== 0) {
      getAndStoreContactsForCustomer(clientId);
    }
  }, [clientId])

  const clearAccountFields = () => {
    setClientId(0);
    setSiteAddr({ text: '', value: 0 });
    setContact({ text: '', value: 0 });
  }

  return (
    <>
      <Form
        onSubmit={handleSubmit}
        render={(formRenderProps) => (
          <FormElement style={{ padding: '2rem', marginBottom: '5rem' }}>
            <fieldset className={'k-form-fieldset'}>
              <div className='form__subtitle'>
                Add job details:
                <button
                  className='form__reset__button'
                  onClick={() => {formRenderProps.onFormReset(); clearAccountFields()}}
                >
                  Clear fields
                </button>
              </div>

              <Divider>
                General Info
              </Divider>

              <Field
                disabled={props.lockEdit}
                data={clientData}
                originalData={clientDataOrig}
                name={'clientName'}
                component={FormDropDownListFilter}
                label={'Choose a client:'}
                setData={setClientData}
                searchDropdown={searchClientDropdown}
                defaultItem={clientId}
                onChange={async (e) => {
                  const selectedClientId = parseInt(e.value.value, 10);
                  setClientId(selectedClientId);
                  
                  // Check if client is a bad debter
                  if (selectedClientId) {
                    const clientData = await getClientByIdV2(selectedClientId);
                    setIsBadDebter(clientData.badDebter || false);
                  }
                }}
                hasButton={props.lockEdit ? false : true}
                buttonText={'Add Account'}
                buttonAction={() => {
                  props.setAddAccountVisible(true)
                  props.setAccountMode("add");
                  props.setAccountInitialTab(0);
                }}
              />

              <Field
                disabled={props.lockEdit}
                data={contactsForClient}
                originalData={siteDataOrig}
                name={'contact'}
                component={FormDropDownListFilter}
                label={'Contact:'}
                setData={setContactsForClient}
                onOpen={() => getAndStoreContactsForCustomer(clientId)}
                searchDropdown={searchSiteDropdown}
                defaultItem={contactsForClient.find(item => Number(item.value) === Number(contact.value))}
                onChange={(e) => {
                  setContact({
                    ...e.value,
                    contactId: parseInt(e.value.value, 10),
                  })
                }}
                hasButton={props.lockEdit ? false : clientId > 0}
                buttonText={'Add Contact'}
                buttonAction={() => {
                  props.setAccountMode("edit");
                  props.setSelectedAccountId(clientId);
                  props.setAccountInitialTab(2);
                  props.setAddAccountVisible(true)
                }}
              />

              <Field
                disabled={props.lockEdit}
                data={siteData}
                originalData={siteDataOrig}
                name={'siteAddr'}
                component={FormDropDownList}
                label={'Address:'}
                setData={setSiteData}
                onOpen={() => getAndStoreAddressesForCustomer(clientId)}
                searchDropdown={searchSiteDropdown}
                defaultItem={siteData.find(item => Number(item.value) === Number(siteAddr.value))}
                onChange={(e) => {
                  setSiteAddr({
                    ...e.value,
                    value: parseInt(e.value.value, 10),
                  })
                }}
                hasButton={props.lockEdit ? false : clientId > 0}
                buttonText={'Add Address'}
                buttonAction={() => {
                  props.setAccountMode("edit");
                  props.setSelectedAccountId(clientId);
                  props.setAccountInitialTab(1);
                  props.setAddAccountVisible(true)
                }}
              />

              <Field
                data={enquirysourceData}
                name={'enquirysourceId'}
                component={FormDropDownList}
                label={'Enquiry source:'}
                placeholder={'Choose job source:'}
              />

              <Field
                name={'description'}
                component={FormTextArea}
                label={'Description:'}
                placeholder={'Enter a description:'}
                validator={requiredValidator}
              />

              {isBadDebter && (
                <div style={{ 
                  backgroundColor: '#fff3cd', 
                  border: '1px solid #ffc107', 
                  borderRadius: '4px', 
                  padding: '12px', 
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <FaFlag style={{ color: '#856404' }} />
                  <span style={{ color: '#856404', fontWeight: 'bold' }}>
                    Bad Debter - Contact accounts department
                  </span>
                </div>
              )}

              <Divider>
                Reminders
              </Divider>
              <JobsRemidners reminders={jobReminders} handleCompleteReminder={handleCompleteReminder} />

              <Divider>
                Job Details
              </Divider>

              <Field
                data={worktypeData}
                name={'worktypeId'}
                component={FormDropDownList}
                label={'Type of Work:'}
                placeholder={'Choose a worktype:'}
                validator={requiredValidator}
                hasButton={true}
                buttonText={'Add Work Type'}
                buttonAction={handleAddWorktype}
              />

              <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                <Label>Notifiable Works:</Label>
                <MultiSelect
                  data={notifiableWorksOptions}
                  value={notifiableWorks}
                  onChange={(e) => setNotifiableWorks(e.value)}
                  placeholder="Select notifiable works..."
                />
              </div>

              <Field
                name={'startDate'}
                component={FormDateTimePicker}
                label={'Start Date:'}
                placeholder={'Enter a start date:'}
                validator={requiredValidator}
              />

              <Field
                name={'endDate'}
                component={FormDateTimePicker}
                label={'End Date:'}
                placeholder={'Enter a end date:'}
                validator={requiredValidator}
              />



              <Field
                data={employeeProjectData}
                originalData={employeeDataOrig}
                name={'employeeProjectManagerId'}
                component={FormDropDownListFilter}
                searchDropdown={searchEmployeeProjectDropdown}
                label={'Project Manager:'}
                setData={setEmployeeProjectData}
                placeholder={'Choose a project manager:'}
                validator={requiredValidator}
              />

              {/* <Field
                data={employeeData}
                originalData={employeeDataOrig}
                name={'jobEmployeeIds'}
                component={FormMultiSelect}
                searchDropdown={searchEmployeeDropdown}
                label={'Employees assigned to job:'}
                setData={setEmployeeData}
                placeholder={'Choose assigned employees:'}
                validator={requiredValidator}
              /> */}

              <Divider>
                Invoice Details
              </Divider>

              <Field
                name={'purchaseOrder'}
                component={FormInput}
                label={'Purchase Order/Works Order:'}
                placeholder={'Enter a PO/WO number:'}
              />

              <div style={{ display: "flex", flexDirection: "row", gap: "50px" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <p style={{ margin: "0 1em 0 0", top: "20px", position: "relative" }}><b>£</b></p>
                  <Field
                    name={'proformaCost'}
                    component={FormNumericTextBox}
                    label={'First hour Invoice Value:'}
                    placeholder={'First hour invoice value:'}
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <p style={{ margin: "0 1em 0 0", top: "20px", position: "relative" }}><b>£</b></p>
                  <Field
                    name={'cost'}
                    component={FormNumericTextBox}
                    label={'Total Job Value:'}
                    placeholder={'Enter total job value:'}
                  />
                </div>
              </div>

              <Label style={{ marginTop: "1em" }}>Invoice type:</Label>
              <DropDownList
                data={invoiceTypesDropdown}
                name='invoiceTypeTemplate'
                onChange={(e: any) => {
                  setInvoiceTypeTemplate(e.target.value)
                }}
              />


            </fieldset>
            <div className='button__container'>
              {
                buttonSpinner ?
                  <button
                    disabled={true}
                    style={{
                      width: '100%',
                      marginTop: '0.5rem',
                      height: '3rem',
                      backgroundColor: 'rgb(174 199 65)',
                      color: 'rgb(71 83 21)',
                      border: 0,
                      borderRadius: '0.3rem',
                    }}
                  >
                    <Loader size="medium" type="infinite-spinner" style={{ color: "rgb(71 83 21)" }} />
                  </button>
                  :
                  <button
                    type={'submit'}
                    disabled={!formRenderProps.allowSubmit || (clientId === 0 || siteAddr.value === 0 || contact.value === 0)}
                    style={{
                      width: '100%',
                      marginTop: '0.5rem',
                      height: '3rem',
                      backgroundColor: 'rgb(174 199 65)',
                      color: 'rgb(71 83 21)',
                      border: 0,
                      borderRadius: '0.3rem',
                    }}
                  >
                    Add job
                  </button>
              }
            </div>
          </FormElement>
        )}
      />
    </>
  )
}

export default AddJobForm
